import { ConfirmModal } from '@affine/component';
import clsx from 'clsx';
import type { ComponentProps } from 'react';

import * as styles from './object-permission-dialog-shell.css';

export type ObjectPermissionDialogShellProps = ComponentProps<
  typeof ConfirmModal
>;

/** Shared modal chrome for document/folder create and configuration flows. */
export const ObjectPermissionDialogShell = (
  props: ObjectPermissionDialogShellProps
) => (
  <ConfirmModal
    {...props}
    headerClassName={clsx(styles.header, props.headerClassName)}
    descriptionClassName={clsx(styles.description, props.descriptionClassName)}
    childrenContentClassName={clsx(
      styles.content,
      props.childrenContentClassName
    )}
    contentOptions={{
      ...props.contentOptions,
      className: clsx(styles.panel, props.contentOptions?.className),
    }}
  />
);
